<template>
    <div class="flex-grow" style="height: 52px;">
        <div v-if="isSales"
             class="select-styling">
            <ais-sort-by
                :items="[
                    { value: `products_${ lang }`, label: $t('Sorteren op relevantie') },
                    { value: `products_${ lang }` + '_sales', label: $t('Sorteren op magazijnstructuur') },
                    { value: `products_${ lang }` + '_article_asc', label: $t('Sorteren op artikelnummer') },
                    { value: `products_${ lang }` + '_names_asc', label: $t('Sorteren op naam laag - hoog') },
                    { value: `products_${ lang }` + '_names_desc', label: $t('Sorteren op naam hoog - laag') }
                ]" />
        </div>

        <div v-else
             class="select-styling">
            <ais-sort-by
                :items="[
                    { value: `products_${ lang }`, label: $t('Sorteren op relevantie') },
                    { value: `products_${ lang }` + '_article_asc', label: $t('Sorteren op artikelnummer') },
                    { value: `products_${ lang }` + '_names_asc', label: $t('Sorteren op naam laag - hoog') },
                    { value: `products_${ lang }` + '_names_desc', label: $t('Sorteren op naam hoog - laag') }
                ]" />
        </div>
    </div>
</template>

<script>
export default {
    name: "AlgoliaSortingSelect",

    props: {
        isSales: {
            type: Boolean,
            default: false
        },
        lang: {
            type: String,
            default: "nl"
        }
    }
}
</script>
